import { render, staticRenderFns } from "./MarketplaceGeneralTable.vue?vue&type=template&id=239306f3&scoped=true&"
import script from "./MarketplaceGeneralTable.vue?vue&type=script&lang=js&"
export * from "./MarketplaceGeneralTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239306f3",
  null
  
)

export default component.exports